import { render, staticRenderFns } from "./PatreonExternaldomains.vue?vue&type=template&id=32e4a4a2&scoped=true"
import script from "./PatreonExternaldomains.vue?vue&type=script&lang=js"
export * from "./PatreonExternaldomains.vue?vue&type=script&lang=js"
import style0 from "./PatreonExternaldomains.vue?vue&type=style&index=0&id=32e4a4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4a4a2",
  null
  
)

export default component.exports